// extracted by mini-css-extract-plugin
export default {"main":"BioBadge_main__VXeUJ","img":"BioBadge_img__HIGxn","notAvailable":"BioBadge_notAvailable__665Z8"};